import { authenticatedFetch } from '../../../shared/utils/authenticatedFetch';
import type { AvailabilityByPosting } from '../types/interviewAvailability';

const PROXY_URL =
  import.meta.env.VITE_PROXY_URL ||
  'https://proxy-prod-520260363689.europe-west3.run.app';

export interface AvailabilityRole {
  postingId: string;
  title: string;
}

/**
 * Two doors to one engine. `radar` is the open TA Cockpit's redacted variant;
 * `board` is the action board's, behind the Candidate Communication gate, which
 * also names the panel and why a light is black. The optional Google token lets
 * the proxy read a role's kick-off sheet when no panel is configured.
 */
export async function fetchInterviewAvailability(
  door: 'radar' | 'board',
  roles: AvailabilityRole[],
  gmailToken?: string | null
): Promise<AvailabilityByPosting> {
  const path =
    door === 'radar' ? '/api/recruiting/interview-availability' : '/api/ta-action-board/interview-availability';
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (gmailToken) headers['X-Gmail-Token'] = gmailToken;
  const res = await authenticatedFetch(`${PROXY_URL}${path}`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ roles }),
  });
  if (!res.ok) throw new Error(`Request failed (${res.status})`);
  const body = (await res.json()) as { availability?: AvailabilityByPosting };
  return body.availability ?? {};
}
